import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { WhitelistAPI } from "../../api/api";

export default function WhitelistEdit() {
  const { id } = useParams();
  const [ip, setIp] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadIP = async () => {
      try {
        const res = await WhitelistAPI.get(id);
        setIp(res.data.ipAddress);
      } catch (err) {
        console.error("Failed to load IP:", err);
      } finally {
        setLoading(false);
      }
    };
    loadIP();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await WhitelistAPI.update(id, { ipAddress: ip });
      navigate("/whitelist");
    } catch (err) {
      console.error("Failed to update IP:", err);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold mb-4">Edit Whitelist IP</h1>
      <form onSubmit={handleSubmit} className="flex space-x-2">
        <input
          type="text"
          value={ip}
          onChange={(e) => setIp(e.target.value)}
          placeholder="Enter IP address"
          className="border px-2 py-1 rounded flex-1"
        />
        <button type="submit" className="px-3 py-1 bg-blue-500 text-white rounded">
          Update
        </button>
      </form>
    </div>
  );
}
